import React from "react";

function AboutModal() {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <button
        className="px-6 py-3 rounded-3xl font-medium bg-blue-400  text-white outline-none focus:outline-none  hover:bg-yellow-500 shadow-md mr-2"
        type="button"
        onClick={() => setShowModal(true)}
      >
        About
      </button>
      {showModal ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            onClick={() => setShowModal(false)}
          >
            <div className="relative w-auto my-6 mx-auto max-w-6xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold">
                    About
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-lg leading-relaxed">
                    GPT-Neo is a transformer based Language model built by <a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href='https://www.eleuther.ai/projects/gpt-neo/' target="_blank" rel="noreferrer">EleutherAI</a>.
                      They Say the model is built in  manner similar to the GPT-3 models created by <a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href='https://www.openai.com' target="_blank" rel="noreferrer">Open AI</a>.
                      The Models were trained on their own corpus <a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href='https://arxiv.org/abs/2101.00027' target="_blank" rel="noreferrer">The Pile</a>
                      <p>
                          <br/>
                      </p>
                      Few have been able to get access to the OpenAI API, so we are incredibly grateful for EleutherAI, and
                      indeed Huggingface 🤗 for making access to the GPT-Neo models easy.</p>
                    <p className="my-4 text-lg leading-relaxed">
                        This site has been built by Tim Williams as a personal project, with no affiliation to any organisation referenced.
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" ></div>
        </>
      ) : null}
    </>
  );
}

function ContactModal() {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <button
        className="px-6 py-3 rounded-3xl font-medium bg-green-400 text-white outline-none focus:outline-none hover:bg-yellow-500 shadow-md"
        type="button"
        onClick={() => setShowModal(true)}
      >
        Contact
      </button>
      {showModal ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            onClick={() => setShowModal(false)}
          >
            <div className="relative w-auto my-6 mx-auto max-w-6xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold">
                    Contact
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-blueGray-500 text-lg leading-relaxed">
                      You can contact me on neo@timajwilliams.com, or find me over on twitter <a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href='https://www.twitter.com/timajwilliams' target="_blank" rel="noreferrer">timajwilliams</a>
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" ></div>
        </>
      ) : null}
    </>
  );
}

export {ContactModal, AboutModal}